import type { CopilotScopeKey } from "@/features/copilot/lib/copilot-query-keys";
import type { CopilotConversation } from "@/features/copilot/schemas/copilot.schema";

export function conversationForCopilotScope(
  conversation: CopilotConversation | null | undefined,
  scope: CopilotScopeKey | null,
): CopilotConversation | null {
  if (!conversation || !scope || conversation.workspaceId !== scope.workspaceId) return null;
  return conversation;
}
